<template>
  <path pid="0" d="M20.49 2H6.56a3 3 0 00-3 2.55l-1.38 9a3 3 0 003 3.45h4.66v3a4 4 0 004 4 1 1 0 00.92-.59L18.49 15h2a3.3 3.3 0 003.32-2.87V4.87A3.3 3.3 0 0020.49 2zm-3.65 11.79l-3.61 8.12A2 2 0 0111.84 20v-4a1 1 0 00-1-1H5.18a1 1 0 01-.78-.34 1 1 0 01-.23-.81l1.38-9a1 1 0 011-.85h10.29zm5-1.87A1.31 1.31 0 0120.53 13h-1.69V4h1.67a1.32 1.32 0 011.33 1.08z"/>
</template>
